/* Campo "Senha" nos kits: aplica um código de desconto no carrinho e mostra o preço novo na hora */
(function(){
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var H={'Content-Type':'application/json','Accept':'application/json'};
  function j(r){if(!r.ok)throw r;return r.json();}
  function getCart(){return fetch(root+'cart.js',{headers:{'Accept':'application/json'}}).then(j);}
  function post(u,b){return fetch(root+u,{method:'POST',headers:H,body:JSON.stringify(b)}).then(j);}
  function brl(c,cur){return (c/100).toLocaleString('pt-BR',{style:'currency',currency:cur||'BRL'});}
  function low(s){return String(s||'').trim().toLowerCase();}
  function setCount(n){
    document.querySelectorAll('[data-mt-count]').forEach(function(el){el.textContent=n;el.hidden=!n;});
  }
  function vidOf(f){
    var box=f.closest('.mt-pbox');var el=box&&box.querySelector('form[data-mt-add] [name=id]');
    return +(el?el.value:f.getAttribute('data-variant'));
  }
  function say(f,txt,kind){
    var m=f.querySelector('[data-mt-senha-msg]');if(!m)return;
    m.textContent=txt;m.classList.toggle('is-ok',kind==='ok');m.classList.toggle('mt-err',kind==='err');
  }

  // Mostra o preço com desconto na caixa de compra
  function mostrar(f,c,code){
    var vid=vidOf(f);
    var li=null;c.items.forEach(function(i){if(i.variant_id===vid&&!li)li=i;});
    if(!li)return false;
    var desc=li.original_line_price-li.final_line_price;
    var codeOk=(c.discount_codes||[]).some(function(d){return d.applicable&&(!code||low(d.code)===low(code));});
    if(!codeOk)return false;
    var box=f.closest('.mt-pbox');var pr=box.querySelector('[data-mt-pr]');
    var unitDe=li.original_price,unitPor=Math.round(li.final_line_price/li.quantity);
    var nome=code||((c.discount_codes||[]).filter(function(d){return d.applicable;})[0]||{}).code||'';
    if(desc>0){
      pr.querySelector('[data-mt-preco]').textContent=brl(unitPor,c.currency);
      var s=pr.querySelector('[data-mt-de]');
      if(!s){s=document.createElement('s');s.setAttribute('data-mt-de','');pr.querySelector('[data-mt-preco]').after(s);}
      s.textContent=brl(unitDe,c.currency);
      var parc=pr.querySelector('[data-mt-parc]');if(parc)parc.hidden=true;
      document.querySelectorAll('[data-mt-sticky-preco]').forEach(function(el){el.textContent=brl(unitPor,c.currency);});
      say(f,'Senha aplicada! Você economiza '+brl(desc,c.currency)+'. O desconto já está no seu carrinho.','ok');
    }else{
      // desconto no total do pedido (não fica preso a um produto)
      var tot=0;(c.cart_level_discount_applications||[]).forEach(function(a){tot+=a.total_allocated_amount||0;});
      if(!tot)return false;
      say(f,'Senha aplicada! Desconto de '+brl(tot,c.currency)+' no total do carrinho.','ok');
    }
    var inp=f.querySelector('input');if(inp&&nome){inp.value=nome;}
    f.classList.add('is-done');
    var feito=box.querySelector('[data-mt-senha-feito]'),comprar=box.querySelector('form[data-mt-add]');
    if(feito){feito.hidden=false;}if(comprar){comprar.hidden=true;}
    return true;
  }

  document.addEventListener('submit',function(e){
    var f=e.target;if(!f.matches('[data-mt-senha]'))return;
    e.preventDefault();
    var inp=f.querySelector('input'),btn=f.querySelector('button[type=submit]');
    var code=(inp.value||'').trim(),vid=vidOf(f),adicionou=null,antes=[];
    if(!code){say(f,'Digite a senha para aplicar o desconto.','err');inp.focus();return;}
    btn.disabled=true;say(f,'Conferindo a senha…');
    getCart().then(function(c){
      antes=(c.discount_codes||[]).map(function(d){return d.code;}).filter(function(x){return low(x)!==low(code);});
      var tem=c.items.some(function(i){return i.variant_id===vid;});
      if(tem)return null;
      // o kit precisa estar no carrinho para a Shopify calcular o desconto
      return post('cart/add.js',{items:[{id:vid,quantity:1}]}).then(function(r){adicionou=r.items&&r.items[0]&&r.items[0].key;});
    }).then(function(){
      return post('cart/update.js',{discount:antes.concat(code).join(',')});
    }).then(function(c){
      setCount(c.item_count);
      if(mostrar(f,c,code))return;
      // senha não vale: desfaz o que fizemos
      var desfaz=post('cart/update.js',{discount:antes.join(',')});
      if(adicionou){desfaz=desfaz.then(function(){return post('cart/change.js',{id:adicionou,quantity:0});});}
      return desfaz.then(function(c2){setCount(c2.item_count);say(f,'Essa senha não é válida para este kit. Confira e tente de novo.','err');inp.focus();});
    }).catch(function(){
      say(f,'Não conseguimos conferir a senha agora. Tente de novo em instantes.','err');
    }).then(function(){btn.disabled=false;});
  });

  // Se o kit já está no carrinho com senha aplicada, já abre a página com o preço novo
  var forms=document.querySelectorAll('[data-mt-senha]');
  if(forms.length){getCart().then(function(c){forms.forEach(function(f){mostrar(f,c,null);});}).catch(function(){});}
})();
